// extracted by mini-css-extract-plugin
module.exports = {"leftText":"LeftPaymentText-module--left-text--2tWcT","title":"LeftPaymentText-module--title--1nCHO"};